module.exports = __webpack_public_path__ + "media/images/npc-9bd5e795acfd2300ce3d3f2bf15da596.png";